import { render, staticRenderFns } from "./userTaskList.vue?vue&type=template&id=125c5d11&scoped=true"
import script from "./userTaskList.vue?vue&type=script&lang=js"
export * from "./userTaskList.vue?vue&type=script&lang=js"
import style0 from "./userTaskList.vue?vue&type=style&index=0&id=125c5d11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125c5d11",
  null
  
)

export default component.exports